import { InsuranceStatus } from '@centecomm/portal-service';
import { useInsurance } from '@centecomm/portal-service-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { globalMessageActionCreators } from 'State';
import { Actions, selectors } from 'State/Insurance';
import { InsuranceActions } from '../../State/Insurance/actions';

interface PendingDocuments {
    insuranceId: number;
    files: File[];
    occupantId: number;
}

function UploadInsuranceDocuments(): React.ReactElement {
    const { t } = useTranslation(['insurance']);
    const dispatch = useDispatch();
    const { addInsuranceDocuments, getInsuranceDocuments } = useInsurance();

    const pendingDocumentsToUpload: PendingDocuments[] = useSelector(selectors.pendingDocumentsToUpload);

    const [isPending, toggleIsPending] = useState<boolean>(false);

    useEffect(() => {
        if (pendingDocumentsToUpload.length > 0 && !isPending) {
            toggleIsPending(true);

            try {
                pendingDocumentsToUpload.forEach(({ insuranceId, files, occupantId }: PendingDocuments) => {
                    addInsuranceDocuments(occupantId, insuranceId, files)
                        .then(() => {
                            dispatch({
                                type: Actions.REMOVE_PENDING_DOCUMENTS,
                                payload: {
                                    files,
                                    insuranceId,
                                },
                            });

                            getInsuranceDocuments(occupantId, insuranceId).then((docs) => {
                                dispatch({
                                    type: InsuranceActions.ADD_INSURANCE_DOCUMENTS,
                                    payload: {
                                        insuranceId,
                                        documents: docs,
                                    },
                                });

                                dispatch({
                                    type: InsuranceActions.EDIT_INSURANCE_STATUS,
                                    payload: {
                                        insuranceId,
                                        occupantId,
                                        status: InsuranceStatus.NotSubmitted,
                                    },
                                });
                            });
                        })
                        .catch((err) => {
                            dispatch(
                                globalMessageActionCreators.addErrorMessage(
                                    t('insurance:forms.documents.errors.upload'),
                                    err,
                                ),
                            );
                        });
                });
            } catch (err) {
                dispatch(globalMessageActionCreators.addErrorMessage(t('insurance:forms.documents.errors.upload'), err));
            } finally {
                toggleIsPending(false);
            }
        }
    }, [pendingDocumentsToUpload]);

    return <></>;
}

export default UploadInsuranceDocuments;
